module.exports = __webpack_public_path__ + "static/media/Action.665c6f7e.jpg";